<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open">
            <div class="modal-content" :class="{'register': !btnOk, 'reConsent': btnOk}">
                <div class="relative bg-a-brown-f5ebdc w-full h-auto py-6 overflow-hidden main-content" :class="{'rounded-20': btnOk}">
                    <div v-if="showClose" class="absolute top-6 right-3" @click="onCancel()">
                        <img class="cursor-pointer w-25px" src="@/assets/icon/ic-close-brown.svg">
                    </div>
                    <div v-if="title" class="text-center text-18 text-a-brown-502314 font-bold lg:text-24" v-html="title"></div>
                    <div class="relative">
                        <div class="relative px-6">
                            <div class="h-full overflow-y-scroll content-scroll"
                                :class="{
                                    'pdpa-content-change': btnOk,
                                    'pdpa-content': btnOk == null,}"
                                @scroll="onScrollContent">
                                <PdpaContent
                                    :type="type"
                                    :localeCode="localeCode"
                                    :v-model:version="version"
                                    @onError="onError($event)"/>
                            </div>
                            <div class="hidden lg:block absolute bottom-0 right-8 z-10" v-if="showToButtom">
                                <img @click="toButtom()" class="w-10" src="@/assets/icon/ic-to-button-desktop.webp" alt="">
                            </div>
                        </div>
                        <div class="absolute bottom-0 left-0 bg-white w-full p-1 z-10 lg:hidden" v-if="showToButtom">
                            <div class="flex gap-1 justify-center items-center" @click="toButtom()">
                                <div class="text-14 text-a-red-d62300">{{lbl.consent.tab_to_button}}</div>
                                <img src="@/assets/icon/ic-to-button.webp" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="flex w-full justify-center pt-5 px-6">
                        <RedButton class="max-w-90" :isDisabled="showToButtom" customClass="w-full text-16 py-2 lg:pt-2 lg:pb-2.5 lg:text-18" v-if="btnOk" @click="onOk()">{{btnOk}}</RedButton>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin.js';
// component
import PdpaContent from '@/components/Authen/Pdpa/PdpaContent.vue';
import RedButton from '@/components/Button/RedButton.vue';

export default {
    name: 'PdpaModal',
    mixins: [LocaleMixin],
    components: {
        PdpaContent,
        RedButton,
    },
    props: {
        controller: { type: Object }
    },
    data: function () {
        return {
            open: false,

            title: '',
            type: '',
            version: '',
            busModal: null,
            showToButtom: true,
            showClose: false,
            btnOk: null,
        };
    },
    created: function () {
        this.busModal = this.controller.busModal;
    },
    mounted: function () {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    methods: {
        //#region event
        onOk: function () {
            if (this.showToButtom) return;
            
            this.hide();
            this.sendCallbackOk(this.version);
        },
        onCancel: function () {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        onError: function (err) {
            this.hide();
            this.controller.alertModal
                .clearModal()
                .setMsg(err.message)
                .show();
        },
        //#endregion event
        show: function (config) {
            this.title = config.title;
            this.type = config.type || 'terms';
            this.btnOk = config.btnOk || null;
            
            if (this.type == 'marketing') {
                this.showToButtom = false;
            } else {
                this.showToButtom = true;
            }

            if (this.btnOk) {
                if (this.type == 'marketing') {
                    this.showClose = true;
                } else {
                    this.showClose = false;
                }
            } else {
                this.showClose = true;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function () {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        sendCallbackOk: function (version) {
            if (this.controller && this.controller.sendCallbackOk) {
                this.controller.sendCallbackOk(version);
            }
        },
        toButtom: function () {
            const element = document.querySelector('.pdpa-content') || document.querySelector('.pdpa-content-change');
            if (element) {
                // Scroll to the bottom of the element
                element.scrollTop = element.scrollHeight;
                
                this.showToButtom = false;
            }
        },
        onScrollContent: function (event) {
            const el = event.target;
            // Check if scrolled to bottom (allowing 1px tolerance)
            if ((el.scrollTop + el.clientHeight) >= (el.scrollHeight - 10)) {
                this.showToButtom = false;
            } else {
                this.showToButtom = true;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import "@/style/base/base.scss";
    @import "@/style/base/display.scss";

    .modal {
        @extend %modal;
        height: 100%;
        max-height: 100vh;
        .modal-content {
            &.register {
                width: 100%;
                height: 100%;
            }
            &.reConsent {
                width: 100%;
                height: auto;
                padding: 16px;
            }
            @include min-desktop {
                height: auto;
                max-width: 770px;
                max-height: 770px;
                padding: 16px;
            }

            .main-content {
                @include min-desktop {
                    border-radius: 20px;
                }
            }

            .pdpa-content {
                max-height: calc(100vh - 120px);

                @include min-desktop {
                    max-height: calc(100vh - 220px);
                }
            }

            .pdpa-content-change {
                max-height: calc(100vh - 200px);
                

                @include min-desktop {
                    max-height: calc(750px - 200px);
                }
            }

            .content-scroll {
                margin-top: 30px;
                @include scrollbar(#9F8273, #D7C7B8);
            }
        }
    }
</style>
